export const parseLanguage = (lng?: string): string => {
  const base = (lng || 'pl').toLowerCase().split('-')[0];
  return base === 'en' ? 'en' : 'pl';
};
